import { motion } from "framer-motion";

const STATS = [
  { id: "stat-card-total-recovered", value: "$150M+", label: "Total Client Verdicts & Settlements" },
  { id: "stat-card-success-rate", value: "99.4%", label: "Case Success Rate" },
  { id: "stat-card-years", value: "21+", label: "Years Active Legal Practice" },
  { id: "stat-card-clients", value: "15,000+", label: "Injured & Oppressed Clients Served" },
];

export const Stats = () => (
  <section id="results" className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
    <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-gold/15 bg-gold/10 lg:grid-cols-4">
      {STATS.map((s, i) => (
        <motion.div
          key={s.id}
          data-testid={s.id}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ delay: i * 0.1, duration: 0.6 }}
          className="bg-navy-900 p-7 sm:p-9"
        >
          <div className="font-display text-3xl sm:text-4xl font-bold text-gold">{s.value}</div>
          <div className="mt-2 text-xs sm:text-sm text-slate-400">{s.label}</div>
        </motion.div>
      ))}
    </div>
  </section>
);
